import md, { type Node } from 'markdown-ast';

export interface RendererProps {
  node: Node;
  children?: React.ReactNode;
  key?: string | number;
}

type Renderers = Record<string, React.ComponentType<RendererProps>>;

export const createMarkDownComponents = (text: string): Node[] => {
  try {
    const components = md(text);
    return components;
  } catch (error) {
    console.error('Error creating markdown components:', error);
    return [
      {
        type: 'text',
        text,
      },
    ];
  }
};

export const MarkdownRenderer: React.FC<{
  content: string;
  renderers: Renderers;
}> = ({ content, renderers }) => {
  const ast = createMarkDownComponents(content);

  const renderNode = (node: Node, index: number): React.ReactNode => {
    const Renderer = renderers[node.type as keyof typeof renderers];

    if (!Renderer) return null;

    const hasChildren = 'block' in node && Array.isArray(node.block);

    return (
      <Renderer key={index} node={node}>
        {hasChildren && node.block.map((child, i) => renderNode(child, i))}
      </Renderer>
    );
  };

  return <>{ast.map(renderNode)}</>;
};
